<template>
  <v-row class="wifi-widget">
    <div class="widget-content">
      <v-layout row class="wifi" @click.stop="openDialog">
        <v-flex xs12>
          <p v-if="useData.wifiTitle" class="title">{{ useData.wifiTitle }}</p>
          <p><v-icon light>mdi-wifi</v-icon> {{ useData.wifiSsid }}</p>
          <p>
            <v-icon light>mdi-lock-question</v-icon> {{ useData.wifiPassword }}
          </p>
          <p v-if="useData.showSpeed">
            <v-icon light>mdi-speedometer</v-icon>
            <span v-if="speed.value">
              {{ speed.value }} {{ speed.units }}
            </span>
            <span v-else class="speed-calc">
              Calculating Speed
            </span>
          </p>
        </v-flex>
      </v-layout>
      <div class="remove-btn wifi">
        <remove-button :widget-position="currentWidget" :widget-name="widgetName" />
      </div>
    </div>
    <v-dialog v-model="dialog" scrollable max-width="500" dark>
      <widgetForm
        :show-form="showForm"
        :widget-schema="formSchema"
        :widget-values="formValues"
        :widget-name="widgetName"
        :widget-position="currentWidget"
        @closeDialog="closeDialog"
      />
    </v-dialog>
  </v-row>
</template>

<script>
import WidgetForm from '../../components/Forms/widgetForm'
import RemoveButton from '../../components/Buttons/RemoveButton'

const imagePre = 'https://images.pexels.com/photos/'
const images = [
  '208821/pexels-photo-208821.jpeg',
  '33287/dog-viszla-close.jpg',
  '1851164/pexels-photo-1851164.jpeg',
  '45201/kitty-cat-kitten-pet-45201.jpeg',
  '68550/thailand-elephant-sunset-nature-68550.jpeg',
  '198162/pexels-photo-198162.jpeg',
  '634612/pexels-photo-634612.jpeg',
  '59523/pexels-photo-59523.jpeg',
  '66280/africa-african-animal-big-66280.jpeg',
  '1321524/pexels-photo-1321524.jpeg',
  '374825/pexels-photo-374825.jpeg',
  '982230/pexels-photo-982230.jpeg',
  '133459/pexels-photo-133459.jpeg',
  '5143/cute-animals-easter-chicken.jpg',
  '730896/pexels-photo-730896.jpeg',
  '1098254/pexels-photo-1098254.jpeg',
  '704454/pexels-photo-704454.jpeg',
  '760984/pexels-photo-760984.jpeg',
  '33284/butterfly-matting-macro-macro-photography.jpg',
  '1322599/pexels-photo-1322599.jpeg',
  '1093126/pexels-photo-1093126.jpeg',
  '302304/pexels-photo-302304.jpeg',
  '1301172/pexels-photo-1301172.jpeg',
  '689784/pexels-photo-689784.jpeg',
  '33394/elephant-ivory-animals-africa.jpg',
  '768078/pexels-photo-768078.jpeg',
  '406014/pexels-photo-406014.jpeg',
  '69932/tabby-cat-close-up-portrait-69932.jpeg',
  '64219/dolphin-marine-mammals-water-sea-64219.jpeg',
  '36018/flamingo-phoenicopterus-flamingos-phoenicopteriformes.jpg',
  '1299391/pexels-photo-1299391.jpeg',
  '706194/pexels-photo-706194.jpeg',
  '66898/elephant-cub-tsavo-kenya-66898.jpeg',
  '87403/cheetah-leopard-animal-big-87403.jpeg',
  '37833/rainbow-lorikeet-parrots-australia-rainbow-37833.jpeg',
  '213399/pexels-photo-213399.jpeg',
  '146083/pexels-photo-146083.jpeg',
  '162318/cheetahs-cubs-two-together-162318.jpeg',
  '62289/yemen-chameleon-chamaeleo-calyptratus-chameleon-reptile-62289.jpeg',
  '52509/penguins-emperor-antarctic-life-52509.jpeg',
  '726478/pexels-photo-726478.jpeg',
  '247431/pexels-photo-247431.jpeg',
  '535431/pexels-photo-535431.jpeg',
  '631292/pexels-photo-631292.jpeg',
  '39571/gorilla-silverback-animal-silvery-grey-39571.jpeg',
  '65320/polar-bear-bear-teddy-sleep-65320.jpeg',
  '257558/pexels-photo-257558.jpeg',
  '53581/bald-eagles-bald-eagle-bird-of-prey-adler-53581.jpeg',
  '1054650/pexels-photo-1054650.jpeg',
  '617278/pexels-photo-617278.jpeg',
  '33550/cows-curious-cattle-agriculture.jpg',
  '41178/africa-animal-big-carnivore-41178.jpeg',
  '259554/pexels-photo-259554.jpeg',
  '50577/hedgehog-animal-baby-cute-50577.jpeg',
  '1405930/pexels-photo-1405930.jpeg',
  '148182/pexels-photo-148182.jpeg',
  '110320/pexels-photo-110320.jpeg',
  '61157/pelicans-pelican-water-bird-australian-pelican-61157.jpeg',
  '730539/pexels-photo-730539.jpeg',
  '325045/pexels-photo-325045.jpeg',
  '1784578/pexels-photo-1784578.jpeg',
  '59829/honey-bee-water-buckfast-59829.jpeg',
  '145939/pexels-photo-145939.jpeg',
  '66400/pexels-photo-66400.jpeg',
  '54081/giraffes-south-africa-safari-africa-54081.jpeg',
  '460223/pexels-photo-460223.jpeg',
  '641283/pexels-photo-641283.jpeg',
  '2971/farm-animals-horses.jpg',
  '183333/pexels-photo-183333.jpeg',
  '39629/tiger-tiger-baby-tigerfamile-young-39629.jpeg',
  '40984/animal-ara-macao-beak-bird-40984.jpeg',
  '34098/south-africa-hluhluwe-giraffes-pattern.jpg',
  '814898/pexels-photo-814898.jpeg',
  '158471/ibis-bird-red-animals-158471.jpeg',
  '288621/pexels-photo-288621.jpeg',
  '1216482/pexels-photo-1216482.jpeg',
  '1126384/pexels-photo-1126384.jpeg',
  '52500/horse-herd-fog-nature-52500.jpeg',
  '60023/baboons-monkey-mammal-freeze-60023.jpeg',
  '434090/pexels-photo-434090.jpeg',
  '45911/peacock-plumage-bird-peafowl-45911.jpeg',
  '1431465/pexels-photo-1431465.jpeg',
  '39627/flamingo-valentine-heart-valentine-s-day-39627.jpeg',
  '1156507/pexels-photo-1156507.jpeg',
  '50988/ape-berber-monkeys-mammal-affchen-50988.jpeg',
  '1181181/pexels-photo-1181181.jpeg',
  '1316294/pexels-photo-1316294.jpeg',
  '17811/pexels-photo.jpg',
  '326900/pexels-photo-326900.jpeg',
  '41315/africa-african-animal-cat-41315.jpeg',
  '889929/pexels-photo-889929.jpeg',
  '160509/ducklings-chicks-mama-duck-160509.jpeg',
  '349758/hummingbird-bird-birds-349758.jpeg',
  '162203/panthera-tigris-altaica-tiger-siberian-amurtiger-162203.jpeg',
  '1599452/pexels-photo-1599452.jpeg',
  '2361/nature-animal-wolf-wilderness.jpg',
  '60692/bird-animal-nature-strauss-60692.jpeg',
  '416204/pexels-photo-416204.jpeg',
  '819372/pexels-photo-819372.jpeg',
  '162140/duckling-birds-yellow-fluffy-162140.jpeg',
  '68767/divers-underwater-ocean-swim-68767.jpeg',
  '677974/pexels-photo-677974.jpeg',
  '35995/hippo-mammal-wildlife-nature.jpg',
  '35060/stork-bird-animal-fly.jpg',
  '4602/jumping-cute-playing-animals.jpg',
  '34106/zebra-wild-animal-africa-stripes.jpg',
  '247661/pexels-photo-247661.jpeg',
  '1683724/pexels-photo-1683724.jpeg',
  '60588/meerkat-animal-wild-wildlife-60588.jpeg',
  '105804/pexels-photo-105804.jpeg'
]

export default {
  name: 'Wifi',
  components: {
    WidgetForm,
    RemoveButton
  },
  props: {
    widgetData: {
      type: Object,
      required: false
    },
    widgetName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      showForm: false,
      currentWidget: this.$attrs.position,
      speed: this.$i18n.t('widgets.wifi.calculating'),
      formValues: {},
      formSchema: {}
    }
  },
  computed: {
    /* Create defaults for this widget */
    useData() {
      return (
        this.widgetData || {
          wifiSsid: 'Wifi Name',
          wifiPassword: 'Wifi Password',
          wifiTitle: 'Wifi Information',
          showSpeed: true,
          updateEvery: 1080000
        }
      )
    }
  },
  destroyed() {
    clearInterval(this.startInterval)
  },
  mounted() {
    this.getWifiSpeed()
    this.startInterval()
  },
  methods: {
    openDialog() {
      this.setFormSchema()
      this.setFormValues()
      this.dialog = true
      this.showForm = true
    },
    setFormSchema() {
      const formSchema = {
        wifiTitle: {
          type: 'text',
          label: this.$i18n.t('widgets.wifi.form.title'),
          hint: 'Leave blank for no title',
          flex: 12
        },
        wifiSsid: {
          type: 'text',
          label: this.$i18n.t('widgets.wifi.form.name'),
          flex: 6
        },
        wifiPassword: {
          type: 'text',
          label: this.$i18n.t('widgets.wifi.form.password'),
          flex: 6
        },
        showSpeed: {
          type: 'switch',
          label: this.$i18n.t('widgets.wifi.form.showSpeed'),
          flex: 6
        },
        updateEvery: {
          type: 'select',
          label: this.$i18n.t('widgets.wifi.form.updateEvery'),
          items: [
            { text: this.$i18n.t('time.freq.30sec'), value: 30000 },
            { text: this.$i18n.t('time.freq.1min'), value: 60000 },
            { text: this.$i18n.t('time.freq.5min'), value: 300000 },
            { text: this.$i18n.t('time.freq.10min'), value: 600000 },
            { text: this.$i18n.t('time.freq.30min'), value: 180000 },
            { text: this.$i18n.t('time.freq.1h'), value: 360000 },
            { text: this.$i18n.t('time.freq.3h'), value: 1080000 }
          ],
          flex: 12
        }
      }
      this.formSchema = formSchema
    },
    setFormValues() {
      this.formValues.wifiTitle = this.useData.wifiTitle || null
      this.formValues.wifiSsid = this.useData.wifiSsid || null
      this.formValues.wifiPassword = this.useData.wifiPassword || null
      this.formValues.showSpeed = this.useData.showSpeed || null
      this.formValues.updateEvery = this.useData.updateEvery || null
    },
    changeWidget(widget) {
      this.dialog = false
      this.$store.dispatch('dashboard/updateWidgetType', {
        [this.currentWidget]: widget
      })
    },
    removeWidget() {
      this.dialog = false
      this.$store.dispatch('dashboard/updateWidgetType', {
        [this.currentWidget]: 'blank'
      })
    },
    /* Close the dialog and reset the props so that state aligns */
    closeDialog() {
      clearInterval(this.startInterval)
      this.dialog = false
      this.showForm = false
      this.setFormValues()
      this.formSchema = {}
      if (this.showSpeed) {
        this.startInterval()
      }
    },
    startInterval() {
      this.$options.interval = setInterval(
        this.getWifiSpeed,
        this.$props.widgetData.updateEvery
      )
    },
    getWifiSpeed() {
      if (this.$props.widgetData.showSpeed) {
        const imageLength = images.length
        const randomNumber =
          Math.floor(Math.random() * (imageLength - 0 + 1)) + 0
        const singleImage = images[randomNumber]
        const chooseUrl = `${imagePre}${singleImage}?${Math.random()}`
        const startTime = new Date().getTime()
        let endTime
        let fileSize
        const xhr = new XMLHttpRequest()
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            endTime = new Date().getTime()
            const duration = (endTime - startTime) / 1000
            fileSize = xhr.responseText.length
            const bitsLoaded = fileSize * 8
            let speedBps = bitsLoaded / duration
            speedBps = speedBps.toFixed(2)
            this.speed = this.calcSpeed(speedBps)
          }
        }
        xhr.open('GET', chooseUrl, true)
        xhr.send()
      }
    },
    calcSpeed(bitsPerSecond) {
      const KBps = (bitsPerSecond / 1024).toFixed(2)
      if (KBps <= 1) return { value: bitsPerSecond, units: 'Bps' }
      const MBps = (KBps / 1024).toFixed(2)
      if (MBps <= 1) return { value: KBps, units: 'KBps' }
      return { value: MBps, units: 'MBps' }
    }
  }
}
</script>

<style lang="scss" scoped>
.wifi {
  color: white;
  text-align: left;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
  .v-icon {
    color: white;
    padding-right: 8px;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
  }
}
</style>

<style lang="scss">
.wifi-widget {
  .remove-btn {
    text-align: center;
    font-size: 12px;
    transition: 0s;
    opacity: 0;
    &.wifi {
      position: relative;
      top: -10px;
    }
  }
  &:hover {
    cursor: pointer;
    .remove-btn {
      opacity: 0.8;
      transition-delay: 1.5s;
      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
    }
  }
  .speed-calc {
    font-size: 10px;
  }
}
.widget-top {
  &.widget-left {
    .wifi-widget {
      justify-content: flex-start;
      margin-left: 20px;
    }
  }
  &.widget-center {
    .wifi-widget {
      justify-content: center;
    }
  }
  &.widget-right {
    .wifi-widget {
      justify-content: flex-end;
      margin-right: 20px;
    }
  }
}
.widget-middle {
  &.widget-left {
    .wifi-widget {
      justify-content: flex-start;
      margin-left: 20px;
    }
  }
  &.widget-center {
    .wifi-widget {
      justify-content: center;
    }
  }
  &.widget-right {
    .wifi-widget {
      justify-content: flex-end;
      margin-right: 20px;
    }
  }
}
.widget-bottom {
  &.widget-left {
    .wifi-widget {
      justify-content: flex-start;
      margin-left: 20px;
    }
  }
  &.widget-center {
    .wifi-widget {
      justify-content: center;
    }
  }
  &.widget-right {
    .wifi-widget {
      justify-content: flex-end;
      margin-right: 20px;
    }
  }
}
</style>
